import { getConfigManager } from '../../config';
import { Decimal, ONE, ZERO } from '../../datastructures';
import accountsAtom from './accountsAtom';
import nostraTokenListAtom from './nostraTokenListAtom';
import { walletAddressAtom } from '../wallet';
import assetTokenRatesAtom from './assetTokenRatesAtom';
import nostraTokenBalancesAtom from './nostraTokenBalanceAtom';
import { createAsyncAtom } from '../../lib/state';

interface AccountTotalAssetsMap {
  [walletAccountIdKey: string]: Decimal;
}

const accountTotalAssetsAtom = createAsyncAtom(async get => {
  const accounts = await get(accountsAtom);
  const nostraTokens = await get(nostraTokenListAtom);
  const walletAddress = await get(walletAddressAtom);
  const nostraTokenBalances = await get(nostraTokenBalancesAtom);
  const tokenRates = await get(assetTokenRatesAtom);

  if (!walletAddress) {
    return {};
  }

  const configManager = getConfigManager();

  const result: AccountTotalAssetsMap = {};
  accounts.forEach((subAccountName, accountId) => {
    if (!subAccountName) {
      return;
    }

    nostraTokens.forEach(nostraToken => {
      try {
        // Do not count debt tokens when calculating total assets for a account
        if (nostraToken.variant === 'debt') {
          return;
        }

        const accountTotalAssetsDataKey = `${walletAddress}-${accountId}`;
        const tokenBalanceKey = `${walletAddress}-${accountId}-${nostraToken.address}`;
        const tokenRate = tokenRates.rate[configManager.getNostraTokenAssetAddress(nostraToken.address)] ?? ONE;
        const tokenBalance = nostraTokenBalances[tokenBalanceKey];

        if (!tokenBalance) {
          return;
        }

        result[accountTotalAssetsDataKey] = (result[accountTotalAssetsDataKey] ?? ZERO).add(
          tokenBalance.mul(tokenRate),
        );
      } catch (error) {
        console.error(
          `useAccountTotalAssets - error calculating total assets for account with id: ${accountId}`,
          error,
        );
      }
    });
  });

  return result;
});
export default accountTotalAssetsAtom;
